import React, { useEffect, useState } from "react";

import AdminListService from "../../../services/admin-list.service";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import ToTop from "../includes/ToTop";
import useTable from "../../../hooks/useTable";
import useSortableData from "../../../hooks/useSortableData";
import Select from "react-select";
import Pagination from "react-js-pagination";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

export default function Dashboard() {
  const state = useSelector((state) => state.stateVals);

  const { manager_id, manager_role } = state;
  const [loading, setLoading] = useState(false);
  const [dashboard, setDashboard] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [limit, setLimit] = useState("20");
  const [active, setActive] = useState("");
  const [filter, setFilter] = useState(null);
  const [resetKey1, setResetKey1] = useState(0);

  const [selectOpt, setSelectOpt] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const [totalResults, setTotalResults] = useState("0");
  const [totalPages, setTotalPages] = useState("1");
  const getManagerData = async () => {
    if (manager_id) {
      try {
        setLoading(true);

        const responce = await AdminListService.getManagersDashboardsData(
          manager_id
        );

        setDashboard(responce.data);
        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
        if (err?.response?.data?.message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            iconColor: "#e04f5d",
            text: err?.response?.data?.message,
            confirmButtonColor: "#e72e2e",
            confirmButtonText: "Try Again",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            iconColor: "#e04f5d",
            text: "Some thing went wrong!",
            confirmButtonColor: "#e72e2e",
            confirmButtonText: "Try Again",
          });
        }
      }
    }
  };
  useEffect(() => {
    getManagerData();
  }, [manager_id]);

  const getRegister = async (
    type,
    page = 1,
    limit = "20",
    id = null,
    start = null,
    end = null
  ) => {
    if (!id) {
      setResetKey1(resetKey1 + 1);
    }
    if (!start && !end) {
      document.querySelectorAll('input[type="date"]').forEach((input) => {
        input.value = "";
      });
    }
    setSelectedIds([]);
    try {
      setLoading(true);

      const responce = await AdminListService.getRegisterDataByType(
        type,
        manager_id,
        id,
        start,
        end,
        page,
        limit
      );

      const res = responce?.data?.registrations || [];
      setFilter(responce?.data?.filters);

      const resultsReg = [];
      res.map((value) => {
        return resultsReg.push({
          store_location: value.store_location,
          customerEmail: value.email,
          customer_F: value.cust_fname,
          customer_L: value.cust_lname,
          phone: value.phone,
          purchase: value.purchase,

          sales_name: value.sales_name,
          date: value.date,
          id: value.id,
        });
      });
      setTableData([...resultsReg]);
      setActive(type);

      setLimit(responce?.data?.per_page || "20");
      setTotalResults(responce?.data?.total_records || "0");
      setTotalPages(responce?.data?.total_pages || "1");
      setCurrentPage(responce?.data?.current_page || "1");
      if (type === "by_store") {
        const results = [];
        responce?.data?.by_store?.map((value) => {
          return results.push({
            value: value.store_id,
            label: value.store_location,
            count: value.total_registrations,
          });
        });
        setSelectOpt([...results]);
      } else if (type === "by_hfc") {
        const results = [];
        responce?.data?.by_hfc?.map((value) => {
          return results.push({
            value: value.hfc_id,
            label: value.sales_name,
            count: value.total_registrations,
          });
        });
        setSelectOpt([...results]);
      } else {
        setSelectOpt([]);
      }

      setLoading(false);
    } catch (err) {
      console.log(err);
      if (type === "by_store") {
        const results = [];
        err.response?.data?.by_store?.map((value) => {
          return results.push({
            value: value.store_id,
            label: value.store_location,
            count: value.total_registrations,
          });
        });
        setSelectOpt([...results]);
      } else if (type === "by_hfc") {
        const results = [];
        err.response?.data?.by_hfc?.map((value) => {
          return results.push({
            value: value.hfc_id,
            label: value.sales_name,
            count: value.total_registrations,
          });
        });
        setSelectOpt([...results]);
      } else {
        setSelectOpt([]);
      }
      setLoading(false);
      setTableData([]);

      setLimit("20");
      setTotalResults("0");
      setTotalPages("1");
      setCurrentPage(1);
    }
  };

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev?.filter((item) => item !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    const pageIds = tableData?.map((item) => item.id);
    const allSelectedOnPage = pageIds?.every((id) => selectedIds?.includes(id));

    if (allSelectedOnPage) {
      // Unselect only current page
      setSelectedIds(selectedIds?.filter((id) => !pageIds?.includes(id)));
    } else {
      // Add current page ids (avoid duplicates)
      const newSelection = [...new Set([...selectedIds, ...pageIds])];
      setSelectedIds(newSelection);
    }
  };
  const exportRecord = async () => {
    setLoading(true);
    try {
      const responce = await AdminListService.getRegisterDataByType(
        active,
        manager_id,
        filter?.id,
        filter?.start_date,
        filter?.end_date,
        1,
        totalResults,
        selectedIds?.length ? selectedIds.join(",") : null
      );
      let resultData = responce?.data?.registrations || [];
      const worksheet = XLSX.utils.json_to_sheet(
        resultData?.map((employ) => ({
          Date: employ?.date || "",
          "Customer First Name": employ?.cust_fname || "",
          "Customer Last Name": employ?.cust_lname || "",
          "Customer Email": employ?.email || "",
          "Customer Phone#": employ?.phone || "",
          "Store Location": employ?.store_location || "",
          HFC: employ?.sales_name || "",
          "Purchase With Purpose": employ?.purchase || "",
        }))
      );
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(
        workbook,
        `${selectedIds?.length ? "Selected " : ""}Registered Users ${active
          ?.replaceAll("_", " ")
          .replace(/\b\w/g, (c) => c.toUpperCase())}.xlsx`
      );
      setSelectedIds([]);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (
        err?.response?.data?.message &&
        typeof err?.response?.data?.message === "string"
      ) {
        toast.warn(err?.response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error("Something went wrong, try again", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };
  const Table = ({ data, rowsPerPage }) => {
    const [page, setPage] = useState(1);
    const { slice } = useTable(data, page, rowsPerPage);
    const { items, requestSort, sortConfig } = useSortableData(slice);
    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    return (
      <div className="table-responsive mt-3">
        <table className="table table-striped table-bordered W-100 sort-ths">
          <thead>
            <tr>
              <th
                scope="col"
                onClick={() => requestSort("date")}
                className={getClassNamesFor("date")}
              >
                <input
                  className="form-check-input "
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={
                    slice?.length > 0 &&
                    slice?.every((item) => selectedIds?.includes(item.id))
                  }
                />{" "}
                No.
              </th>
              <th
                scope="col"
                onClick={() => requestSort("date")}
                className={getClassNamesFor("date")}
              >
                Date
              </th>
              <th
                scope="col"
                onClick={() => requestSort("customer_F")}
                className={getClassNamesFor("customer_F")}
              >
                Customer First Name
              </th>
              <th
                scope="col"
                onClick={() => requestSort("customer_L")}
                className={getClassNamesFor("customer_L")}
              >
                Customer Last Name
              </th>

              <th
                scope="col"
                onClick={() => requestSort("customerEmail")}
                className={getClassNamesFor("customerEmail")}
              >
                Customer Email
              </th>
              <th
                scope="col"
                onClick={() => requestSort("phone")}
                className={getClassNamesFor("phone")}
              >
                Customer Phone#
              </th>
              <th
                scope="col"
                onClick={() => requestSort("store_location")}
                className={getClassNamesFor("store_location")}
              >
                Store Location
              </th>
              <th
                scope="col"
                onClick={() => requestSort("sales_name")}
                className={getClassNamesFor("sales_name")}
              >
                HFC
              </th>
              <th
                scope="col"
                onClick={() => requestSort("purchase")}
                className={getClassNamesFor("purchase")}
              >
                Purchase With Purpose
              </th>
            </tr>
          </thead>
          <tbody>
            {items.length ? (
              items.map((el, index) => (
                <tr key={el?.id}>
                  <td>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectedIds?.includes(el.id)}
                      onChange={() => {
                        toggleSelect(el?.id);
                      }}
                    />{" "}
                    {currentPage === 1
                      ? index + 1
                      : (currentPage - 1) * limit + index + 1}
                  </td>
                  <td>{el.date}</td>
                  <td>{el.customer_F}</td>
                  <td>{el.customer_L}</td>
                  <td>{el.customerEmail}</td>
                  <td>{el.phone}</td>
                  <td>{el.store_location}</td>
                  <td>{el.sales_name}</td>
                  <td>{el.purchase}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center text-capitalize">
                  No record found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {totalResults > limit && totalPages > 1 ? (
          <Pagination
            activePage={currentPage}
            itemsCountPerPage={parseInt(limit)}
            totalItemsCount={totalResults}
            onChange={(e) => {
              getRegister(
                active,
                e,
                limit,
                filter?.id,
                filter?.start_date,
                filter?.end_date
              );
            }}
            pageRangeDisplayed={8}
            itemClass="page-item"
            linkClass="page-link"
            firstPageText="First Page"
            lastPageText="Last Page"
          />
        ) : (
          ""
        )}
      </div>
    );
  };

  const exportCounts = async (type) => {
    // let resultData =
    //   selectOpt.length && active === type
    //     ? selectOpt
    //     : type === "by_store"
    //     ? dashboard?.by_store || []
    //     : dashboard?.by_hfc || [];

    let resultData = selectOpt.length && active === type ? selectOpt : [];
    const worksheet = XLSX.utils.json_to_sheet(
      resultData?.map((employ) =>
        type === "by_store"
          ? {
              "Store Location": employ?.label || employ?.store_location || "",
              "Total Registrations":
                employ?.count || employ?.total_registrations || "",
            }
          : {
              HFC: employ?.label || employ?.sales_name || "",
              "Total Registrations":
                employ?.count || employ?.total_registrations || "",
            }
      )
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      `Counts ${type
        ?.replaceAll("_", " ")
        .replace(/\b\w/g, (c) => c.toUpperCase())}.xlsx`
    );
  };

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        {/* <div className="col-12 add-space-btns">
          <Link to="/searchcomp_pav" className="btn btn-primary mt-2">
            Mail Merge
          </Link>
          <Link className="btn btn-primary mt-2" to="/searchmail_pav_hard">
            Card to be Mailed
          </Link>
          <Link to="/searchmail_pav_virtual" className="btn btn-primary mt-2">
            Virtual Card
          </Link>
        </div> */}
        <div className="row row-cols-2 row-cols-lg-4 g-2 g-lg-3 mb-4">
          {manager_role === "administrator" && (
            <div className="col">
              <div
                className={`card ${active === "company_total" ? "active" : ""}`}
              >
                <h6 className="card-header">Company Total</h6>
                <div className="card-body text-center">
                  <h3 className="card-title">
                    {active === "company_total"
                      ? totalResults || 0
                      : dashboard?.company_total || 0}
                  </h3>

                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      getRegister("company_total", 1, limit);
                    }}
                    disabled={active === "company_total"}
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="col">
            <div className={`card ${active === "by_store" ? "active" : ""}`}>
              <h6 className="card-header">
                {manager_role === "administrator"
                  ? "All Store Totals"
                  : "Store Total"}{" "}
              </h6>
              <div className="card-body text-center">
                <h3 className="card-title">
                  {active === "by_store"
                    ? totalResults || 0
                    : dashboard?.by_store?.reduce(
                        (sum, ad) => sum + ad.total_registrations,
                        0
                      ) || 0}
                </h3>

                <button
                  className="btn btn-primary"
                  onClick={() => {
                    getRegister("by_store", 1, limit);
                  }}
                  disabled={active === "by_store"}
                >
                  View
                </button>
                {active === "by_store" && (
                  <button
                    className="btn btn-primary ms-1"
                    onClick={() => {
                      exportCounts("by_store");
                    }}
                  >
                    Export
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col">
            <div className={`card ${active === "by_hfc" ? "active" : ""}`}>
              <h6 className="card-header">By HFC</h6>
              <div className="card-body text-center">
                <h3 className="card-title">
                  {active === "by_hfc"
                    ? totalResults || 0
                    : dashboard?.by_hfc?.reduce(
                        (sum, ad) => sum + ad.total_registrations,
                        0
                      ) || 0}
                </h3>

                <button
                  className="btn btn-primary"
                  onClick={() => {
                    getRegister("by_hfc", 1, limit);
                  }}
                  disabled={active === "by_hfc"}
                >
                  View
                </button>
                {active === "by_hfc" && (
                  <button
                    className="btn btn-primary ms-1"
                    onClick={() => {
                      exportCounts("by_hfc");
                    }}
                  >
                    Export
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col">
            <div className={`card ${active === "by_date" ? "active" : ""}`}>
              <h6 className="card-header">By Date Range</h6>
              <div className="card-body text-center">
                <h3 className="card-title">
                  {active === "by_date"
                    ? totalResults || 0
                    : dashboard?.by_date?.reduce(
                        (sum, ad) => sum + ad.total_registrations,
                        0
                      ) || 0}
                </h3>

                <button
                  className="btn btn-primary"
                  onClick={() => {
                    getRegister("by_date", 1, limit);
                  }}
                  disabled={active === "by_date"}
                >
                  View
                </button>
              </div>
            </div>
          </div>
        </div>

        {active && (
          <>
            {selectOpt?.length ? (
              <div className="list-store-hfc">
                {selectOpt.map((value) => (
                  <div
                    className={`custom-info ${
                      Number(filter?.id) === value.value ? "active" : ""
                    }`}
                    key={value.value}
                    onClick={() => {
                      setFilter((prev) => ({
                        ...prev,
                        id:
                          Number(filter?.id) !== value.value
                            ? value.value || null
                            : null,
                      }));
                      getRegister(
                        active,
                        1,
                        limit,
                        Number(filter?.id) !== value.value
                          ? value.value || null
                          : null,
                        filter?.start_date,
                        filter?.end_date
                      );
                    }}
                  >
                    <span>{value.count || 0}</span>
                    {value.label}
                  </div>
                ))}
              </div>
            ) : null}

            <div className="card mt-4">
              <div className="card-header py-3">
                <h5 className="mb-0 font-22">
                  Registered Users [{totalResults || 0}]
                  {totalResults > 0 && (
                    <button
                      type="button"
                      onClick={exportRecord}
                      className="btn btn-primary d-inline-block float-end btn-sm"
                    >
                      Export{" "}
                      {selectedIds?.length
                        ? "Selected"
                        : filter?.id || (filter?.start_date && filter?.end_date)
                        ? "Filtered"
                        : "All"}{" "}
                      Record
                    </button>
                  )}
                </h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-3">
                    <div className="input-field-box mb-lg-0">
                      <label>Show Record</label>
                      <select
                        className="form-select"
                        onChange={(e) => {
                          getRegister(
                            active,
                            1,
                            e.target.value,
                            filter?.id,
                            filter?.start_date,
                            filter?.end_date
                          );
                        }}
                      >
                        <option value="20">20</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                        <option value="1500">1500</option>
                        {/* <option value={totalResults}>All</option> */}
                      </select>
                    </div>
                  </div>
                  {/* {active === "by_store" || active === "by_hfc" ? (
                    <div className="col-md-2 ms-auto">
                      <div className="input-field-box mb-lg-0">
                        <label>
                          {active === "by_store"
                            ? "Select Store Location"
                            : "Select HFC"}{" "}
                        </label>
                        <div className="input-group">
                          <Select
                            key={resetKey1}
                            className="border-0 form-control form-label mb-0 p-0"
                            placeholder={
                              active === "by_store" ? "Store Location" : "HFC"
                            }
                            options={selectOpt}
                            isSearchable={true}
                            isClearable={true}
                            onChange={(selectedOption) => {
                              setFilter((prev) => ({
                                ...prev,
                                id: selectedOption?.value || null,
                              }));
                              getRegister(
                                active,
                                1,
                                limit,
                                selectedOption?.value || null,
                                filter?.start_date,
                                filter?.end_date
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : null} */}
                  {active === "by_date" ||
                  active === "by_store" ||
                  active === "by_hfc" ? (
                    <div
                      className={`col-md-4 ms-auto`}
                      // className={`col-md-4 ${
                      //     active === "by_date" ? "ms-auto" : ""
                      //   }`}
                    >
                      <div className="input-field-box mb-lg-0">
                        <label>Select Date Range</label>
                        <div className="input-group">
                          <input
                            type={"date"}
                            className={`form-control `}
                            onChange={(e) => {
                              setFilter((prev) => ({
                                ...prev,
                                start_date: e.target.value || null,
                              }));
                              if (
                                (e.target.value && filter?.end_date) ||
                                (!e.target.value && !filter?.end_date)
                              ) {
                                getRegister(
                                  active,
                                  1,
                                  limit,
                                  filter?.id,
                                  e.target.value,
                                  filter?.end_date
                                );
                              }
                            }}
                          />
                          <input
                            type={"date"}
                            className={`form-control `}
                            onChange={(e) => {
                              setFilter((prev) => ({
                                ...prev,
                                end_date: e.target.value || null,
                              }));
                              if (
                                (e.target.value && filter?.start_date) ||
                                (!e.target.value && !filter?.start_date)
                              ) {
                                getRegister(
                                  active,
                                  1,
                                  limit,
                                  filter?.id,
                                  filter?.start_date,
                                  e.target.value
                                );
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                <Table data={tableData} rowsPerPage={limit} />
              </div>
            </div>
          </>
        )}
      </main>
      <ToTop />
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}
